<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="区域管理">
    </pageTitle>

    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="addRow(row.row)">
            <i class="iconfont icon-bianji"></i> 新增
          </div>
          <div class="button button_modify" @click="editRow(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="deleteRow(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
        </div>
      </template>
    </basicList>

    <el-dialog
      :title="addform.id? '修改区域': '新增区域'"
      :visible.sync="visible"
      custom-class="addProductPopUpWindow"
      :close-on-click-modal="false"
      width="500px"
      append-to-body
    >
      <el-form ref="addform" :model="addform" label-position="top">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="父级" prop="parent_name">
              <el-input
                v-model="addform.parent_name"
                placeholder="请输入区域名称"
                disabled
              ></el-input>

              <!-- <treeselect
                :options="parentOptions"
                placeholder="请选择"
                v-model="addform.parent_id"
              ></treeselect> -->
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="区域编号" prop="area_number">
              <el-input
                v-model="addform.area_number"
                placeholder="请输入区域编号"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="区域名称" prop="name">
              <el-input
                v-model="addform.name"
                placeholder="请输入区域名称"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="24" v-if="addform.id">
            <el-form-item label="排序" prop="sequence">
              <el-input
                v-model="addform.sequence"
                placeholder="请输入排序"
              ></el-input>
            </el-form-item>
          </el-col> -->

        </el-row>
      </el-form>
      <div slot="footer">

        <el-button type="info" @click="closeProduct">取消</el-button>
        <el-button type="success" @click="submit">{{
          addform.id ? "立即修改" : "立即添加"
        }}</el-button>

      </div>
    </el-dialog>


  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { areaGetlist,areaDel,areaUp,areaAdd } from "@/api/basicConfiguration";
export default {
  name: "regionalManagement",
  components: { Treeselect },
  data() {
    return {
      // 所有的区域编码
      areaNumberList:[],
      // 弹窗参数
      visible: false,
      addform: {
        parent_name: null,
        parent_id: null,
        name: null,
        sequence: null,
        area_number: '',

        pre_number: '', // 添加节点时使用
        old_number:'', // 修改节点时使用
      },
      parentOptions: [],
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "区域名称",
            type: "input",
            key: "name",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "area_number",
            width:100,
          },
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "父级区域",
            prop: "parent_name",
          },
          // {
          //   label: "排序",
          //   prop: "sequence",
          //   //sortable: true,
          // },
        ],
        isPage: false,
        total: 0,
        searchParameters: {},
      },
    };
  },
  created() {
    // 初始化列表内容
    this.getlist();
  },
  methods: {
    addSequenceToTree(nodes) {
      // 遍历树的每个节点
      return nodes.map((node, index) => {
        // 给当前节点添加序号，序号是当前节点在父节点children中的位置（从1开始）
        node.sequence = index + 1;
        // 如果当前节点有子节点，则递归处理子节点
        if (node.children && node.children.length > 0) {
          node.children = this.addSequenceToTree(node.children);
        }
        return node;
      });
    },

    // 开弹窗
    editRow(row) {
      this.addform = row //JSON.parse(JSON.stringify(row));
      // this.addform.old_number = this.addform.area_number; // 保留一份旧编号，用来判断是否更改了编号
      this.visible = true;
    },
    // 关弹窗
    closeProduct() {
      this.visible = false;
    },

    // 提交
    submit() {
      // 编辑
      if(this.addform.id) {
        areaUp({
          id:this.addform.id,
          name: this.addform.name,
          area_number: this.addform.area_number
        }).then(res=>{
          if(res.code==1) {
            this.$message.success('更新成功');
            this.getlist();
          } else {
            this.$message.error('更新失败' + res['msg']);
          }
        })
      // 新增
      } else {
        if(!this.addform.area_number) {
          this.$message.error('区域必须有编码');
          return;
        }
        if(!this.addform.name) {
          this.$message.error('区域必须有名称');
          return;
        }
        areaAdd({
          name: this.addform.name,
          area_number: this.addform.area_number,
          parent_id: this.addform.parent_id,
        }).then(res=>{
          if(res.code==1) {
            this.$message.success('新增成功');
            this.getlist();
          } else {
            this.$message.error('新增失败' + res['msg']);
          }
        })
      }
      this.visible = false;
    },

    // 搜索
    searchEvent(data, page) {
      if (page) {
        this.basicListconfig.page = page;
        this.basicListconfig.page = page;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.basicListconfig.searchParameters.limit = 10000;
        this.getlist();
      }
    }, 

    // 获取列表
    getlist() {
      this.basicListconfig.loading = true;
      areaGetlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = this.addAreaNumber(res.data)
         
          // 自动生成排序编号 
          // this.basicListconfig.data = this.addSequenceToTree(this.basicListconfig.data);
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    addAreaNumber(nodes) {
      return nodes.map((node, index) => {
        this.areaNumberList.push(node.area_number)
        if (node.children && node.children.length > 0) {
          node.children = this.addAreaNumber(node.children);
        }
        return node;
      });
    },
    // 自动生成区域编码
    genAreaNumber(parent_number) {
      let filteredArray = this.areaNumberList.filter(str=>str.startsWith(parent_number)).filter(str=>str.length==parent_number.length+3);
console.log('--debug1')
console.log(this.areaNumberList)
console.log(filteredArray)
      if(filteredArray.length==0) {
        let areaNumberChar = parent_number[parent_number.length - 3];
        let nextLetter = String.fromCharCode(areaNumberChar.charCodeAt(0) + 1);
        return parent_number + nextLetter + '01'
      } else {
        let areaNumberChar = filteredArray[0][parent_number.length];

        // 使用 map() 方法将每个字符串的最后两位转换成数字
        let lastTwoAsNumbers = filteredArray.map(item => parseInt(item.slice(-2), 10));

        // 使用 Math.max() 找出最大值
        let maxNumber = Math.max(...lastTwoAsNumbers);

        return parent_number + areaNumberChar + ((maxNumber+1)>10?(maxNumber+1):'0'+(maxNumber+1))
      }
    },
    // 增加
    addRow(row) {
console.log('--debug--')
console.log(row)
      this.$confirm("请选择：增加同级节点，还是子节点?", "提示", {
        confirmButtonText: "子级别",
        cancelButtonText: "同级别",
        type: "warning",

      // 子级别节点   
      }).then(() => {
        this.addform = JSON.parse(JSON.stringify(row));
        delete this.addform.children
        this.addform.id = 0,
        this.addform.name = '',
        this.addform.area_number = this.genAreaNumber(row.area_number),
        this.addform.parent_id = row.id,
        this.addform.parent_name = row.name,
        this.visible = true;  

      // 同级别节点    
      },()=>{
        this.addform = JSON.parse(JSON.stringify(row));
        delete this.addform.children
        this.addform.id = 0,
        this.addform.name = '',
        this.addform.area_number = this.genAreaNumber(row.area_number.slice(0, -3)), // 去掉最后3个字符，即为父节点area_number
        this.addform.parent_id = row.parent_id,
        this.addform.parent_name = row.parent_name,
        this.visible = true;
      });
    },

    // 删除
    deleteRow(row) {
      // 非叶子节点，不允许删除
      if (row.children && Array.isArray(row.children) && row.children.length > 0) {
        this.$message.error('不能直接删除，请先删除其下所有节点');
        return false;
      }
      this.$confirm("此操作将删除该节点数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        areaDel({id:row.id}).then(res=>{
          if(res.code==1) {
            this.$message.success('删除成功');
            this.getlist();
          } else {
            this.$message.error('删除失败');
          }
        })
      });
    },



  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/regionalManagement/index.vue